import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class PaymentHoursAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      ignores_debts: 1,
      training_id: '',
      certification_id: '',
      training_certification_id: '',
      certification_type_id: '',
      certification_supplier_id: '',
      training_selected: 0,
      certification_selected: 0,
      hour_value: '',
      hours_paid: '',
      pnf_paid: '',
      double_paid: '',
      hours_total: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleSelectChangeTraining = this.handleSelectChangeTraining.bind(this);
    this.handleSelectChangeTrainingCertification = this.handleSelectChangeTrainingCertification.bind(this);
    this.handleSelectChangeCertification = this.handleSelectChangeCertification.bind(this);
    this.handleSelectChangeTypeStaff = this.handleSelectChangeTypeStaff.bind(this);

    this.StaffclearSelects = this.StaffclearSelects.bind(this);
    this.TrainingclearSelects = this.TrainingclearSelects.bind(this);
    this.CertificationclearSelects = this.CertificationclearSelects.bind(this);
    this.loadTrainingCertifications = this.loadTrainingCertifications.bind(this);
    this.loadTrainingCertificationData = this.loadTrainingCertificationData.bind(this);
    this.loadHourValue = this.loadHourValue.bind(this);
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeHour (name, event) {
    var change = {};
    var valido = /^[\d,.]+$/.test(event.target.value);
    if (event.target.value === "" || valido === true) {
      var self = this;
      change[name] = event.target.value
      this.setState(change);
      window.setTimeout(function(){ 
        self.handleChangeHourTotal();
      }, 200);
    }
  }

  handleChangeHourTotal (name, event) {
    var hour_value = this.state.hour_value;

    if (this.state.hours_paid) {
      var hours_paid = parseFloat(this.state.hours_paid.replace(',', '.'));
    }
    if (this.state.pnf_paid) {
      var pnf_paid = parseFloat(this.state.pnf_paid.replace(',', '.'));
    }
    if (this.state.double_paid) {
      var double_paid = parseFloat(this.state.double_paid.replace(',', '.'));
    }

    if (isNaN(hours_paid)) {
      hours_paid = 0;
    }
    if (isNaN(pnf_paid)) {
      pnf_paid = 0;
    }
    if (isNaN(double_paid)) {
      double_paid = 0;
    }
    if (isNaN(hour_value)) {
      hour_value = 0;
    }
    
    var addition = pnf_paid + hours_paid + double_paid;
    var total = addition * hour_value;
    this.setState({hours_total: total.toFixed(2)});
  }

  handleSelectChangeTraining(name, event) {   
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.TrainingclearSelects();
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadTrainingCertifications(event);
      });
    }
  }
  handleSelectChangeTypeStaff(name, event) {   
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.StaffclearSelects();
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadHourValue(event);
      });
    }
  }

  handleSelectChangeTrainingCertification(name, event) {   
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.CertificationclearSelects();
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadTrainingCertificationData(event);
      });
    }
  }
  
  handleSelectChangeCertification(name, event) {   
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.CertificationclearSelects();
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadCertificationData(event);
      });
    }
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  TrainingclearSelects() {
    this.setState({training_selected: 0});
    this.setState({training_certification_id: ''});
    this.setState({certification_type_id: ''});
    this.setState({certification_supplier_id: ''});
    this.setState({date_start: ''});
    this.setState({date_finish: ''});
    this.setState({training_code: ''});
    this.loadData();
  }

  StaffclearSelects() {
    this.setState({staff_selected: 0});
    this.setState({hour_value: 1});
    this.setState({hours_total: ''});
    this.loadData();
  }

  CertificationclearSelects() {
    this.setState({certification_type_id: ''});
    this.setState({certification_supplier_id: ''});
    this.setState({date_start: ''});
    this.setState({date_finish: ''});
    this.loadData();
  }


  loadCertificationData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/certificado/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certification_id: responseJson.data.id});
          self.setState({certification_type_id: responseJson.data.certification_type_id});
          self.setState({training_certification_type_id: responseJson.data.training_certification_type_id});
          self.setState({certification_suppliers_list: responseJson.certification_suppliers_list});
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }
  loadTrainingCertificationData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certification_id: responseJson.data.certification_id});
          self.setState({certification_type_id: responseJson.data.certification.certification_type_id});
          self.setState({training_certification_type_id: responseJson.data.training_certification_type_id});
          self.setState({certification_supplier_id: responseJson.data.certification_supplier.id});
          self.setState({date_start: responseJson.data.date_start_str});
          self.setState({date_finish: responseJson.data.date_finish_str});
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  loadHourValue(event) {
    var datasave = {
      staff_id: this.state.staff_id,
      certification_type_id: this.state.certification_type_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulante/valor/hora', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({hour_value: responseJson.data});
          self.handleChangeHourTotal();
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadTrainingCertifications(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificados/lista/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data});
          self.setState({training_selected: 1});
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
      var url = config.get('api') + '/treinamento/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({training_code: responseJson.data.code});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* dados do treinamento */
    }); 
  }

  loadData () {
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamentos/codigos/lista/completo';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({trainings_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificados/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificado/tipos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({certification_types_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificados/fornecedores/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({certification_suppliers_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staffs_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de staffs */ }); /* Lista de certification_suppliers */ }); /* Lista de training_certification_types */ }); /* Lista de training_certifications */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      training_id: this.state.training_id,
      training_certification_id: this.state.training_certification_id,
      certification_supplier_id: this.state.certification_supplier_id,
      certification_id: this.state.certification_id,
      certification_type_id: this.state.certification_type_id,
      training_certification_type_id: this.state.training_certification_type_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staff_id: this.state.staff_id,
      hour_value: this.state.hour_value,
      hours_paid: this.state.hours_paid,
      double_paid: this.state.double_paid,
      pnf_paid: this.state.pnf_paid,
      hours_total: this.state.hours_total,
      observation: this.state.observation,
      ignores_debts: this.state.ignores_debts,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/hora/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/pagamentos/abertos/horas';
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Adicionar pagamento</h3>
      <Link to="/pagamentos/abertos/horas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Treinamento:</label>
              <Select
                className="form-field-name"
                name="training_id"
                value={this.state.training_id}
                searchable={true}
                placeholder={'Selecionar treinamento'}
                onChange={this.handleSelectChangeTraining.bind(this, 'training_id')}
                options={this.state.trainings_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Aula:</label>
              <Select
                required={true}
                className="form-field-name"
                name="training_certification_id"
                value={(this.state.training_selected === 1) ? this.state.training_certification_id : this.state.certification_id}
                searchable={true}
                placeholder={'Selecionar aula'}
                onChange={(this.state.training_selected === 1) ? this.handleSelectChangeTrainingCertification.bind(this, 'training_certification_id') : this.handleSelectChangeCertification.bind(this, 'certification_id')}
                options={this.state.certifications_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Código do treinamento:</label>
              <input type="text" name="training_code" className="form-control" placeholder="" value={this.state.training_code} disabled="disabled" onChange={this.handleChange.bind(this, 'training_code')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Tipo:</label>
              <Select
                required={true}
                className="form-field-name"
                name="certification_type_id"
                value={this.state.certification_type_id}
                searchable={true}
                placeholder={'Selecionar tipo'}
                onChange={this.handleSelectChangeTypeStaff.bind(this, 'certification_type_id')}
                options={this.state.certification_types_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Data inicial:</label>
              <InputMask required value={this.state.date_start} disabled={this.state.training_selected === 0 ? "" : "disabled"} maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data final:</label>
              <InputMask required value={this.state.date_finish} disabled={this.state.training_selected === 0 ? "" : "disabled"} maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Local:</label>
              <Select
                className="form-field-name"
                name="certification_supplier_id"
                value={this.state.certification_supplier_id}
                disabled={this.state.training_selected === 0 ? "" : "disabled"}
                placeholder={'Local'}
                onChange={this.handleSelectChange.bind(this, 'certification_supplier_id')}
                options={this.state.certification_suppliers_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Tripulante:</label>
              <Select
                required={true}
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                placeholder={'Selecionar tripulante'}
                onChange={this.handleSelectChangeTypeStaff.bind(this, 'staff_id')}
                options={this.state.staffs_list}
              />
            </div>
          </div>
        </div>  
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Horas pagas:</label>
              <input type="text" required value={this.state.hours_paid} name="hours_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'hours_paid')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Horas PNF pagas:</label>
              <input type="text" value={this.state.pnf_paid} name="pnf_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'pnf_paid')} placeholder="" />
            </div>
          </div>
        </div>  
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Horas dobradas:</label>
              <input type="text" value={this.state.double_paid} name="double_paid" className="form-control" onChange={this.handleChangeHour.bind(this, 'double_paid')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Valor hora:</label>
              <input value={this.state.hour_value} disabled="disabled" name="hour_value" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
            </div>
          </div>
        </div>  
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Total Pago:</label>
              <input value={this.state.hours_total} disabled="disabled" name="hours_total" className="form-control" onChange={this.handleChange.bind(this, 'hours_total')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Observação:</label>
              <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder="Observação" />
            </div>
          </div>
        </div>  
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar pagamento</button>
          </div>
        </div>
      </form>    
    </div>
  </div>
</div>
    );
  }
}

export default PaymentHoursAdd;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentHoursAdd.js